import {
  ColorPicker,
  IconPicker,
} from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, Switch } from 'antd'
import { useEffect } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedParticipationStatus } from '../../../store/membership/ParticipationStatusReducer'
import { requiredRule } from '../../../utils/rules'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedParticipationStatus())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="name" rules={[requiredRule()]} label={'Name'}>
        <Input />
      </Form.Item>
      <Form.Item name="icon" label="Icon">
        <IconPicker />
      </Form.Item>
      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>
      <Form.Item
        label="Default Status"
        name="isDefault"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
    </Form>
  )
}

export default Update
